/** CEO Command — Command Item models (review v1 Cut A). */
export const FOCUS_BUCKETS = [
    "act_now",
    "decision_required",
    "waiting",
    "at_risk",
    "monitoring",
    "all_active",
];
export const COMMAND_TYPES = [
    "EXECUTE",
    "APPROVE",
    "DECIDE",
    "DELEGATE",
    "REVIEW",
    "CONTACT",
    "ESCALATE",
    "MONITOR",
    "ACKNOWLEDGE",
    "CLASSIFY",
];
export const COMMAND_DOMAINS = [
    "SALES",
    "FINANCE",
    "OPERATIONS",
    "PEOPLE",
    "LEGAL",
    "PROJECTS",
    "PARTNERSHIPS",
    "CUSTOMER",
    "RISK",
    "PERSONAL",
];
export const COMMAND_STATUSES = [
    "NEW",
    "READY",
    "IN_PROGRESS",
    "WAITING",
    "DELEGATED",
    "MONITORING",
    "SNOOZED",
    "COMPLETED",
    "DISMISSED",
    "SUPERSEDED",
    "FAILED",
];
/** Compute priority score from factors (review §9 conceptual formula). */
export function computePriorityScore(f) {
    const materiality = (f.financialImpact + f.strategicImpact) / 2;
    const urgency = (f.urgency + f.deadlinePressure + f.riskOfInaction) / 3;
    const leverage = (f.executiveRelevance +
        f.likelihoodOfChangingOutcome +
        f.relationshipImportance) /
        3;
    const confidence = (f.confidence + f.dataFreshness) / 2;
    const raw = materiality * 0.3 +
        urgency * 0.25 +
        leverage * 0.25 +
        confidence * 0.2 +
        f.dependencyBlockage * 0.05 +
        f.suppressedTaskPressure * 0.05 -
        f.delegatability * 0.15 -
        f.automationSuitability * 0.15;
    return Math.max(0, Math.min(100, Math.round(raw * 100)));
}
export function requiresCeo(item) {
    return (item.executiveRelevance >= 0.55 &&
        item.priorityFactors.delegatability < 0.7 &&
        item.priorityFactors.automationSuitability < 0.75);
}
//# sourceMappingURL=command.js.map